import { useSelector } from 'react-redux';
import { userDaSubProfessions } from '../../../../../constants';
import { UserProfession } from '../../../../../enums/UserProfession';
import { Colors } from '../../../../../themes/colors';
import { filterObjectKeys } from '../../../../../utils';
import { EducationUtils } from '../../../../../utils/EducationUtils';
import { jobTitleMaxLength } from '../../shared/constants';
import { FormCard } from '../../shared/FormCard';
import { FormField } from '../../shared/FormField';
import { getErrorStyle, getProfessionCode } from '../../shared/utils';

export const GeneralInformationCard = ({
  formValues,
  handleChange,
  handleProfessionChange,
  errorStatus,
}) => {
  const allProfessions = useSelector((state) =>
    (state.jobs.allProfessions || []).filter((it) => it.code !== UserProfession.DN),
  );

  const userEducation = useSelector((state) => state.users.userEducation);

  const availableSpecialties = Object.keys(
    filterObjectKeys(userEducation?.specialtiesAndProcedures, 'specialty'),
  );

  return (
    <FormCard
      title="General Job Information"
      style={{ marginTop: 16 }}
      contentStyle={{ width: '80%' }}
    >
      <FormField label="Office Name" required>
        <input
          disabled
          className="form-control"
          style={{ maxWidth: '100%', ...getErrorStyle(errorStatus?.invalidOffice) }}
          type="text"
          value={formValues?.office ? formValues.office?.office_name : ''}
        />
      </FormField>

      <div style={{ height: 1, backgroundColor: Colors.neutral_200 }} />

      <FormField label="Job Listing Title" required>
        <input
          className="form-control"
          style={{ maxWidth: '100%', ...getErrorStyle(errorStatus?.invalidJobTitle) }}
          type="text"
          placeholder="Job Listing Title"
          value={formValues.jobTitle}
          onChange={(e) => handleChange('jobTitle', e.target.value)}
          maxLength={jobTitleMaxLength}
        />
        <span style={{ color: '#999999' }}>{jobTitleMaxLength} Character Max</span>
      </FormField>

      <div style={{ display: 'flex', gap: 10, marginTop: 18 }}>
        <FormField label="Profession Type" required>
          <select
            className="custom-select custom-select-lg"
            style={{ height: 32, ...getErrorStyle(errorStatus?.invalidProfessionType) }}
            value={getProfessionCode(formValues) || ''}
            onChange={(val) => handleProfessionChange(val.target.value)}
          >
            <option value="">Select Profession</option>
            {[...allProfessions, ...userDaSubProfessions]?.map((el) => (
              <option key={el.code} value={el.code}>
                {el.name}
              </option>
            ))}
          </select>
        </FormField>

        <FormField label="Office Specialty" required>
          <select
            className="custom-select custom-select-lg"
            style={{ height: 32, ...getErrorStyle(errorStatus?.invalidOfficeSpecialty) }}
            value={formValues.officeSpecialty}
            onChange={(val) => handleChange('officeSpecialty', val.target.value)}
          >
            <option value="">Select a Specialty</option>
            {availableSpecialties.map((specialty) => (
              <option key={specialty} value={specialty}>
                {EducationUtils.removeSpecialtyPrefix(specialty)}
              </option>
            ))}
          </select>
        </FormField>
      </div>
    </FormCard>
  );
};
